import { render, staticRenderFns } from "./BuildPlane.vue?vue&type=template&id=1b2d5509&scoped=true"
import script from "./BuildPlane.vue?vue&type=script&lang=js"
export * from "./BuildPlane.vue?vue&type=script&lang=js"
import style0 from "./BuildPlane.vue?vue&type=style&index=0&id=1b2d5509&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2d5509",
  null
  
)

export default component.exports